export const GET_CHARACTERS_SUCCESS = 'GET_CHARACTERS_SUCCESS';
export const GET_CHARACTERS_PENDING = 'GET_CHARACTERS_PENDING';
export const ADD_CHARACTER = 'ADD_CHARACTER';
